<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="12" md="6">
          <b-card no-body class="mx-4">
            <b-card-body class="p-4">
              <b-form v-on:keyup.enter="(e) => resolveStep(e, step)">
                <h1>{{ $t('register') }}</h1>

                 <template v-if="step == 'info'">
                    <p class="text-muted">{{ $t('basicInformation') }}</p>

                    <b-form-group>
                      <InputField name="name" :label="this.$t('name')" v-model="name" @error="fieldError"
                        :rules="{required:true, length: {min: 2}}"
                    />
                    </b-form-group>

                    <b-form-group>
                      <InputField name="email" type="email" :label="this.$t('email')" v-model="email" @error="fieldError"
                          :errors="httpErrors.email"
                          :rules="{required:true, length: {min: 2}}"
                        />
                    </b-form-group>

                    <b-form-group>
                      <InputField name="project_name" :label="this.$t('projectName')" v-model="project_name" @error="fieldError"
                          :rules="{length: {min: 2, max: 30}}"
                      />
                    </b-form-group>

                    <b-form-group>
                      <InputField type="password" name="password" :label="this.$t('password')" v-model="password" @error="fieldError"
                          :rules="{required:true, length: {min: 2}}"
                      />
                    </b-form-group>

                    <b-form-group>
                      <InputField type="password" name="confirm_password" :label="this.$t('confirmPassword')" v-model="confirm_password" @error="fieldError"
                          :errors="extendErrors['confirm_password']"
                          :rules="{required:true, length: {min: 2}}"
                      />
                    </b-form-group>
                    
                    <b-button variant="success" block @click="(e) => resolveStep(e, 'info')" v-if="template">{{ $t('confirm') }}</b-button>
                    <b-button variant="success" block @click="(e) => register(e)" :disadbled="registering" v-else> <span v-if="registering"> <b-spinner small /> </span> <span v-else> {{ $t('register') }} </span></b-button>
                </template>

                <template v-if="step == 'template'">
                  <b-row class="mb-4">
                    <b-col cols="12"> <a style="text-decoration:underline" @click="showTemplate = true"> <small>{{ $t('registrationTemplateInstallDisclaimer', {name:this.$translateLabel(this.template.template.label)}) }} </small></a> </b-col>
                    <b-sidebar id="template" :title="$translateLabel(template.label)" right v-model="showTemplate" no-header backdrop>
                      <div class="px-3 py-2">
                        <Description :item="template" type="single" />
                      </div>
                    </b-sidebar>
                  </b-row>
                  <b-button variant="success" block @click="(e) => resolveStep(e, 'template')" :disabled="registering" v-if="activationCode"> <span v-if="registering"> <b-spinner small /> </span> <span v-else>{{ $t('register') }} </span></b-button>
                  <b-button variant="success" block @click="(e) => resolveStep(e, 'template')" :disabled="registering" v-else> <span v-if="registering"> <b-spinner small /> </span> <span v-else>{{ $t('registerAndBuy') }} {{ price }} {{ currency }} </span></b-button>
                  
                </template>

                <div class="col-md-12 text-center" style="margin-top: 20px"> <h3>- {{ $t('or') }} -</h3></div>

                 <div class="col-md-12 text-center" style="margin-top: 20px"><router-link to="/login" > {{ $t('signIn') }} </router-link></div>

              </b-form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import IdentityFields from "@/components/identityFields/IdentityFields"
import Input from "@/components/form/Input"
import Select from '@/components/form/Select'
import { Switch as cSwitch } from '@coreui/vue'
import PaymentInfo from '../projects/Settings/PaymentInfo.vue'
import Template from "../../lib/Template"
import publicHttp from "../../shared/publicHttp"
import Description from "../templates/Description"

export default {
  components: {
    IdentityFields,
    InputField: Input,
    SelectField: Select,
    cSwitch,
    PaymentInfo,
    Description
  },
  name: 'Register',
  data: function() {
    return {
      step: 'info',
      appMode: this.$env.get('MODE'),
      name: "",
      email: "",
      project_name: "My Company",
      password: "",
      ref: "",
      confirm_password: "",
      errors: [],
      registering: false,
      httpErrors: [],
      extendErrors: {},
      template: null,
      showTemplate: false,
      fields: {
        name: {
          key: 'name',
          type: "text",
          module: "input",
          name: this.$t('name'),
          constraints: {
              required: true,
              length: {
                  min: 3
              },
              not_allowed_words: ""
          }
        },
        email: {
          key: 'email',
          type: "email",
          module: "input",
          name: this.$t('email'),
          constraints: {
              required: true,
              not_allowed_words: ""
          }
        },
        project: {
          key: 'project',
          type: "text",
          module: "input",
          name: this.$t('projectName'),
          constraints: {
              length: {
                  min: 2,
                  max: 55
              },
              not_allowed_words: ""
          }
        },
        password: {
          key: 'password',
          type: "password",
          module: "input",
          name: this.$t('password'),
          constraints: {
              required: true,
              length: {
                  min: 7,
                  max: 50
              },
          }
        },
        confirmPassword: {
          key: 'confirm_password',
          type: "password",
          module: "input",
          name: this.$t('confirmPassword'),
          constraints: {
              required: true,
              length: {
                  min: 7,
                  max: 50
              },
          }
        }
      }
    }
  },
  methods: {
    fieldError(error) {
      let found = this.errors.find((i, e) => {
          return i.field == error.field
      })

      if (found === undefined) {
          this.errors.push(error)
      } else {
          this.errors.map(e => {
              if (found.field == e.field)
                  e.error = error.error
          })
      }
     },

    translate(label) {
      try {
        return label.locales[this.locale]
      } catch {
        return false
      }
    },

  checkForErrors() {
      return this.errors.find((i, e) => {
          return i.error
      })
  },

    register(e) {
      e.preventDefault()
      this.registering = true

      if (this.checkForErrors()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))
        return
      }

      let products = []
      if (this.template) {
        products.push({
          product_type: "template",
          reference: this.template.template.id,
          source: "template"
        })
      }

      this.$http.post("/v1/user/register_legacy", {
        name: this.name,
        email: this.email,
        password: this.password,
        project_name: this.project_name,
        ref: this.ref,
        products: products,
        lang: this.$i18n.locale
      }).then(resp => {
        let project = resp.data

        this.$gtag.event('register_completed', {project: project})

        if (resp.status == 100) {
          this.$bvToast.toast(this.$t('failedToSetupTrialOnRegister'), {
            type: 'warning'
          })
        }

        this.$bvModal.msgBoxOk(this.$t('confirmationEmail')).then(() => {
          this.$router.push("/login")
        });
      }).catch(error => {
        this.registering = false

        if (error.response !== undefined) {
          if (error.response.status == 500) {
            this.$serverErrorModal(error)
            return
          }

          if (error.response.status == 417) {
            let errors = error.response.data.errors
            if (errors['email'] !== undefined) {
              this.step = 'info';
            }

            this.httpErrors = errors
          }

          this.$bvModal.msgBoxOk(error.response.data.message)
        }

        this.$debugLog(error)
        this.$bvToast.toast(this.$t('unexpectedError'), {
          title: this.$t('error'),
          variant: 'danger'
        })
        
      })
    },

    back(step) {
      this.errors = []
      this.step = step
    },

    proceed(e, step) {
      e.preventDefault();

      if (this.checkForErrors()) {
        this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

        return
      }

      this.step = step;
    },

    resolveStep(e, step) {
      this.step = step;
      this.steps[step](e);
    }
  },

  computed: {
    steps() {
      return {
        info: (e) => {
          if (this.template) {
           return this.proceed(e, 'template')
          }

          return this.register(e)
        },
        template: (e) => this.register(e)
      }
    },


    locale() {
      if (this.$route.query.lang) {
        return this.$route.query.lang
      }

      return this.$store.getters.getLocale
    },

    activationCode() {
      return this.$route.query.activation_code
    },

    price() {
      return new Template(this.template).priceInCurrency(this.currency)
    },

    currency() {
      return this.$route.query.currency || "usd"
    }
  },

  watch: {
    "confirm_password": function(n, o) {
       if (n != this.password) {
         this.extendErrors["confirm_password"] = ["password_not_match"]
       } else {
          delete this.extendErrors["confirm_password"];
       }
    },

    "password": function(n, o) {
      if (n == this.password) {
          delete this.extendErrors["confirm_password"];
      }
    },

    "email": function(n, o) {
      delete this.httpErrors["email"];
    }
  },

  mounted() {
    this.ref = this.$route.query.ref

    if (this.$route.query.template) {
      publicHttp.get("/v1/project/template/" + this.$route.query.template).then((resp) => {
        this.template = new Template(
            resp.data,
            this.locale,
            this.activationCode
        )
      })
    }

  }
}
</script>
